export const TIME_FORMAT = {
    LONG: '24',
    SHORT: '12'
}

export const PART_OF_DAY = {
    AM: 'AM',
    PM: 'PM'
}

export class TimeHelper {

    static hours(format) {
        const hours = [];
        const min = format === TIME_FORMAT.LONG ? 0 : 1
        const max = format === TIME_FORMAT.LONG ? 23 : 12

        for (let i = min; i <= max; i++) {
            if (i < 10) {
                hours.push({ value: '0' + i, label: '0' + i });
            } else {
                hours.push({ value: i, label: i });
            }
        }

        return hours;
    }

    static get minutes() {
        const minutes = [];

        for (let i = 0; i < 60; i++) {
            if (i < 10) {
                minutes.push({ value: '0' + i, label: '0' + i });
            } else {
                minutes.push({ value: i, label: i });
            }
        }

        return minutes;
    }

    static get partsOfDay() {
        return [
            { value: PART_OF_DAY.AM, label: PART_OF_DAY.AM },
            { value: PART_OF_DAY.PM, label: PART_OF_DAY.PM },
        ]
    }

}